module.exports = __webpack_public_path__ + "img/prize-05.b4713040.png";